/*
  tr-localization.js — tiroir pays / devise / langue.

  Écoute au niveau du document plutôt que par composant : le pied de page
  et le tiroir de menu rendent tous deux ce bloc, et l'un d'eux peut être
  injecté après coup par l'éditeur de thème. Un seul écouteur les couvre,
  présents ou à venir.
*/

(function () {
  const OPEN_CLASS = 'tr-loc--open';

  function panelOf(node) {
    const host = node.closest('[data-loc]');
    return host ? host.querySelector('.tr-loc__panel') : null;
  }

  function close(host) {
    const panel = host.querySelector('.tr-loc__panel');
    const trigger = host.querySelector('[data-loc-open]');
    host.classList.remove(OPEN_CLASS);
    if (panel) panel.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.style.removeProperty('overflow');
  }

  function closeAll() {
    document.querySelectorAll('[data-loc].' + OPEN_CLASS).forEach(close);
  }

  document.addEventListener('click', function (event) {
    const opener = event.target.closest('[data-loc-open]');
    if (opener) {
      const host = opener.closest('[data-loc]');
      const panel = panelOf(opener);
      if (!host || !panel) return;
      const isOpen = host.classList.contains(OPEN_CLASS);
      closeAll();
      if (isOpen) return;
      host.classList.add(OPEN_CLASS);
      panel.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      // Le fond ne doit pas défiler sous le tiroir : sur mobile, la page
      // continuait de bouger derrière la liste des pays.
      document.documentElement.style.overflow = 'hidden';
      return;
    }

    if (event.target.closest('[data-loc-close]')) {
      const host = event.target.closest('[data-loc]');
      if (host) close(host);
      return;
    }

    const option = event.target.closest('[data-loc-value]');
    if (option) {
      const form = option.closest('form');
      const field = form && form.querySelector('[data-loc-field]');
      if (!form || !field) return;
      field.value = option.dataset.locValue;
      form.submit();
      return;
    }

    if (!event.target.closest('.tr-loc__panel')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  // Filtre de la liste des pays. On compare sans accents ni casse :
  // « ETATS » doit trouver « États-Unis », sinon le filtre ne sert qu'à
  // ceux qui tapent déjà exactement le bon nom.
  function normalise(value) {
    return value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  document.addEventListener('input', function (event) {
    const field = event.target.closest('[data-loc-search]');
    if (!field) return;
    const group = field.closest('.tr-loc__group');
    if (!group) return;
    const needle = normalise(field.value.trim());
    group.querySelectorAll('.tr-loc__option').forEach(function (option) {
      const item = option.parentElement;
      item.hidden = needle !== '' && !normalise(option.textContent).includes(needle);
    });
  });
})();
